import { render, staticRenderFns } from "./AgentRegister.vue?vue&type=template&id=8bfbaa42&scoped=true"
import script from "./AgentRegister.vue?vue&type=script&lang=js"
export * from "./AgentRegister.vue?vue&type=script&lang=js"
import style0 from "./AgentRegister.vue?vue&type=style&index=0&id=8bfbaa42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfbaa42",
  null
  
)

export default component.exports